function moveWondermentBlock() {
  const mobileWrapper = document.querySelector('.product__info-wrapper.mobile-stack-display');
  const desktopWrapper = document.querySelector('.product__info-wrapper:not(.mobile-stack-display)');

  if (!mobileWrapper || !desktopWrapper) return;

  const observer = new MutationObserver((mutations, obs) => {
    const mobileBlock = mobileWrapper.querySelector('[id^="shopify-block-"][id*="_wonderment_pdp_etas_"]');
    const etaText = mobileBlock?.querySelector('#wonderment-pdp-eta-eta-text')?.innerText?.trim();

    if (mobileBlock && etaText?.length > 0 && !mobileBlock.dataset.movedToDesktop) {
      const desktopBlock = desktopWrapper.querySelector('[id^="shopify-block-"][id*="_wonderment_pdp_etas_"]');

      if (desktopBlock) {
        // Replace desktop with mobile version
        desktopBlock.replaceWith(mobileBlock);
      }

      mobileBlock.dataset.movedToDesktop = "true";
      obs.disconnect();
    }
  });

  observer.observe(mobileWrapper, { childList: true, subtree: true });

  // Fallback: move if MutationObserver doesn't catch it
  setTimeout(() => {
    const mobileBlock = mobileWrapper.querySelector('[id^="shopify-block-"][id*="_wonderment_pdp_etas_"]');
    const desktopBlock = desktopWrapper.querySelector('[id^="shopify-block-"][id*="_wonderment_pdp_etas_"]');
    const etaText = mobileBlock?.querySelector('#wonderment-pdp-eta-eta-text')?.innerText?.trim();

    if (mobileBlock && !mobileBlock.dataset.movedToDesktop && etaText?.length > 0) {
      if (desktopBlock) {
        desktopBlock.replaceWith(mobileBlock);
      }

      mobileBlock.dataset.movedToDesktop = "true";
    }
  }, 3000);
}